import { GetServerSideProps } from 'next';

import { ssrRedirect } from '@helpers/ssrRedirect';

const Home = () => null;

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  return ssrRedirect(res, {
    destination: '/',
    permanent: false,
  });
};

export default Home;
